var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('section', {
    class: _vm.$style.informationBlock
  }, [_vm._t("title", function () {
    return [_vm.title ? _c('h3', {
      class: _vm.$style.title
    }, [_vm._v("\n      " + _vm._s(_vm.title) + "\n    ")]) : _vm._e()];
  }), _vm._v(" "), _c('div', {
    class: _vm.$style.content
  }, [_vm._t("default")], 2)], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };